import authRoutes from "./AuthRoutes";
import { Navigate, useRoutes } from "react-router-dom";
import dashboardRoutes from "./DashboardRoutes";
import { IRoute } from "../interfaces/AppInterfaces";
import adminRoutes from "./AdminRoute";
import otherRoutes from "./OtherRoutes";

const routes = [
  ...authRoutes,
  ...dashboardRoutes,
  ...adminRoutes,
  ...otherRoutes,
  {
    path: "*",
    element: <Navigate to="/auth/login" replace />,
    children: [],
  },
];

export default routes;

export const RouteToRender = ({ route }: { route: IRoute[] }) => {
  const element = useRoutes(route);
  return element;
};
